import $ from 'jquery'
import FileUpload from '@/js/plugins/fileUpload'

const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

export default class extends FileUpload {
    constructor(params) {
        super(params);
        const valueObj = this.settings.targetObj.querySelector('input.input-image');
        const observer = new MutationObserver(mutations => {
            console.log(mutations);
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                        console.log('value changed:', mutation.target.value);
                    if(mutation.target.value){
                        this.settings.targetObj.querySelector('.preview').classList.add('is-loaded');
                    }else{
                        this.settings.targetObj.querySelector('.preview').classList.remove('is-loaded');
                    }
                }
            });
        });
        observer.observe(valueObj, {
            attributes: true,
            attributeFilter: ['value'],
        });
    }
    defaults() {
        return {
            ...super.defaults(),
            typeFilter: ['image.*'],
            fileSizeLimit: 30,
            uploadPath: '/api/upload/image',
            appendHeaders: {
                'X-CSRF-TOKEN': token,
            },
            defaultImagePath: null,
        }
    }

    loadedFile(element, reader) {
        this.settings.prevPath = $(element).find('figure img').attr('src')
        $(element).find('figure').remove();
        let imgObj = $('<img />').attr('src', reader.result)
        imgObj = $('<figure />').addClass('photo uploading').show().append(imgObj);
        $(element).find('.preview').prepend(imgObj);
        //$(element).find('.preview').addClass('is-loaded');
    }

    uploadedFile(element, resp) {
        $(element).find('figure').removeClass('uploading')
        $(element).find('input.input-image').val(resp.file.key)
        this.triggerEvent($(element).find('input.input-image').get(0), 'change')
    }

    deletedFile(element, resp) {
        if(this.settings.defaultImagePath){
            $(element).find('figure img').attr('src', this.settings.defaultImagePath)
        } else {
            $(element).find('figure').remove();
        }
        $(element).find('input.input-image').val('')
        //$(element).find('.preview').removeClass('is-loaded');
        this.triggerEvent($(element).find('input.input-image').get(0), 'change')
    }
    setCloneObj(obj) {
        obj.find('figure').remove()
    }
    error(element, params = null) {
        if (this.settings.prevPath) {
            $(element).find('figure').removeClass('uploading')
                .find('img').attr('src', this.settings.prevPath)
        } else {
            $(element).find('figure').remove()
        }
        if (params && "description" in params){
            alert(params.description)
        }else{
            alert("ファイルのアップロードに失敗しました。\nファイルの形式やフォーマットをご確認ください。")
        }
    }
    triggerEvent(element, event){
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, true, true); // event type, bubbling, cancelable
        return element.dispatchEvent(evt);
    }
}
